import React, { useRef, useState } from 'react';
import Button from './ButtonComponent';

const Option = ({children, onClick, style}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const  optionStyle = {
        background: isHovered ? '#F1F2F4' : '#FFFFFF',
        fontSize: '14px',
        color: '#121417',
        padding: '16px 16px',
        fontWeight: '400',
        borderRadius: '16px',
        border: '2px solid #FFF ',
        transition: 'background 0.3s',
        cursor: 'pointer',
        display: 'inline-flex'
      };
    
      return (
        <button
          style={{...optionStyle, ...style}}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={onClick}
        >
          {children}
        </button>
      )
};

const OptionsButton = ({ children, options }) => {
    const [isSelected, setIsSelected] = useState(false);
    const ref = useRef(null)
    const optionsButtonStyle = {
        position: 'relative'
    };
    const onClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            closeOptions()
        }
      }
    const openOptions = (event) => {
        event.stopPropagation()
        setIsSelected(true);
        document.addEventListener('click', onClickOutside)
    }

    const closeOptions = () => {
        document.removeEventListener('click', onClickOutside);
        setIsSelected(false);
    }
    const optionsStyle = {
        position: 'absolute',
        border: '1px solid white',
        right: '0',
        top: '44px',
        background: '#FFFFFF',
        borderRadius: '25px',
        padding: '8px',
        fontSize: '16px',
        fontFamily: "'Noto Sans', sans-serif",
        fontWeight: '400',
        lineHeight: '24px',
        letterSpacing: '0px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
        width: 'max-content',
        display: 'flex',
        flexDirection: 'column'
    };

    return options && (
            <div  ref={ref} style={optionsButtonStyle}>
                <Button onClick={(event) => isSelected? closeOptions(): openOptions(event)}>
                    {children}
                </Button>
                { isSelected ? 
                    (
                        <div style={optionsStyle}>
                        { options.map( (option, index) => (
                            <Option style={option.style} key={index} onClick={option.onClick}>
                            {option.text}
                            </Option>
                        ))}
                    </div>
                    )
                : (<></>) }
            </div>
        );
};

export default OptionsButton;